import './styles/Footer.css';

function Footer() {

    return (
        <div className="footer">
            <div className="footer-top">
                <img src={'/denny logo.svg'} alt="Denny Logo"/>
                <p className="footer-body">For more than 70 years, DENNY has been a Proudly South African household name.</p>
                <div className="footer-links">
                    <div className="footer-nav">
                        <a href="/lets-cook" className="footer-link">Let's Cook</a> |
                        <a href="/recipes" className="footer-link">Recipes</a> |
                        <a href="/products" className="footer-link">Products</a> |
                        <a href="/about-us" className="footer-link">About Us</a> |
                        {/*<a href="/fan-recipes" className="footer-link">Fan Recipes</a> |*/}
                        <a href="/campaigns" className="footer-link">Campaigns</a> |
                        <a href="/blogs" className="footer-link">Blogs</a> |
                        <a href="/contact-us" className="footer-link">Contact Us</a>

                    </div>
                    <div className="footer-socials">
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.facebook.com/dennysouthafrica/',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.6-1.6h1.7V4.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.5-4 4.2V11H8v3h2.7v8h2.8z"/>
                            </svg>
                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.instagram.com/dennysouthafrica/',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1 0 16.5 12 4.5 4.5 0 0 0 12 7.5zm0 2A2.5 2.5 0 1 1 9.5 12 2.5 2.5 0 0 1 12 9.5zm5-3a1 1 0 1 0 1 1 1 1 0 0 0-1-1z"/>
                            </svg>
                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.youtube.com/@Denny_SouthAfrica',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="#022161" d="M23 12s0-3.1-.4-4.5c-.2-.8-.9-1.5-1.7-1.7C19.5 5.4 12 5.4 12 5.4s-7.5 0-8.9.4c-.8.2-1.5.9-1.7 1.7C1 8.9 1 12 1 12s0 3.1.4 4.5c.2.8.9 1.5 1.7 1.7 1.4.4 8.9.4 8.9.4s7.5 0 8.9-.4c.8-.2 1.5-.9 1.7-1.7.4-1.4.4-4.5.4-4.5zm-13 3.2V8.8L16 12l-6 3.2z"/>
                            </svg>
                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://pin.it/1SZtNy3xb',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                aria-label="Pinterest"
                            >
                                <circle cx="12" cy="12" r="12" fill="#FFFFFF" />

                                <path
                                    fill="#022161"
                                    transform="translate(6.3 4.3) scale(0.03)"
                                    d="M204 6.5C101.4 6.5 0 74.9 0 185.6C0 256 39.6 296 63.6 296
            c9.9 0 15.6-27.6 15.6-35.4c0-9.3-23.7-29.1-23.7-67.8
            c0-80.4 61.2-137.4 140.4-137.4c68.1 0 118.5 38.7 118.5 109.8
            c0 53.1-21.3 152.7-90.3 152.7c-24.9 0-46.2-18-46.2-43.8
            c0-37.8 26.4-74.4 26.4-113.4c0-66.2-93.9-54.2-93.9 25.8
            c0 16.8 2.1 35.4 9.6 50.7c-13.8 59.4-42 147.9-42 209.1
            c0 18.9 2.7 37.5 4.5 56.4c3.4 3.8 1.7 3.4 6.9 1.5
            c50.4-69 48.6-82.5 71.4-172.8c12.3 23.4 44.1 36 69.3 36
            c106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                                />
                            </svg>


                        </div>
                        <div className="social-icon" onClick={() =>
                            window.open(
                                'https://www.tiktok.com/@dennysouthafrica?is_from_webapp=1&sender_device=pc',
                                '_blank',
                                'noopener,noreferrer'
                            )
                        }>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                aria-label="TikTok"
                            >
                                <circle cx="12" cy="12" r="12" fill="#FFFFFF" />

                                <path
                                    fill="#022161"
                                    transform="translate(-2.2 0)"
                                    d="M14.76 5.1h2.76c.12 1.72 1.02 2.88 2.58 3.52v2.67c-1.03-.08-1.91-.36-2.76-.84v4.79c0 2.59-2.1 4.68-4.68 4.68s-4.68-2.09-4.68-4.68 2.1-4.68 4.68-4.68c.38 0 .76.05 1.12.13v2.72a2.36 2.36 0 1 0 1.0 1.83V5.1z"
                                />
                            </svg>

                        </div>
                    </div>

                </div>
                <div className="footer-links-legal">
                <div className="footer-nav">
                    <a href="/privacy-policy" className="footer-link">Privacy Policy</a> |
                    {/*<a href="/" className="footer-link">PAIA Manual</a> |*/}
                    {/*<a href="/" className="footer-link">Personal Information Protection Policy</a> |*/}
                    <a href="/denny-cook-club-terms-conditions" className="footer-link">Terms & Conditions</a> |
                    <a href="/disclaimer" className="footer-link">Disclaimer</a>
                </div>
            </div>

            </div>
            <div className="footer-bottom">
                <div className="libstar-logo">
                    <a href="https://www.libstar.co.za/"
                       target="_blank" rel="noreferrer"><img src={"/libstar logo.svg"} alt={"Libstar Logo"} /> </a>
                </div>
                <div className="copyright-footer">
                    LEARN MORE AT{" "}
                    <a
                        href="https://www.libstar.co.za/"
                        target="_blank" rel="noreferrer"
                        className="libstar-link"

                    >
                        WWW.LIBSTAR.CO.ZA
                    </a>
                    {" | "}
                    ©{new Date().getFullYear()} COPYRIGHT OF DENNY®. | ALL RIGHTS RESERVED.
                </div>
            </div>
        </div>
    )
}

export default Footer;
